import { Box, Text } from '@chakra-ui/react';
import { Children, ReactNode } from 'react';

interface DetailCardProps {
  title?: string;
  children: ReactNode;
}

const DetailCard = ({ title, children }: DetailCardProps) => {
  const childArray = Children.toArray(children);

  return (
    <Box>
      {title && (
        <Text size="xs" mb={1}>
          {title}
        </Text>
      )}
      <Box p={6} bg="white" borderRadius={8}>
        {Children.map(childArray, (child, index) => {
          if (!child) return null;
          // Inject isLast prop into DetailRow children
          if (typeof child === 'object' && 'props' in child) {
            return { ...child, props: { ...child.props, isLast: index === childArray.length - 1 } };
          }
          return child;
        })}
      </Box>
    </Box>
  );
};

export default DetailCard;
